


































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import meterPO from "@/store/entities/devices/fictitiousmeterpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  components: { TreeSelect },
})
export default class CreateFictitiousMeter extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  meterPO: meterPO = new meterPO();
  loading: boolean = false;
  async created() {
    this.areaTree();
    await this.getOrganizations();
    await this.getPrice();
  }
  //
  async loadmeter(node, instanceId) {
    this.$data.meterList = [];
    await this.$store
      .dispatch({ type: "meter/getOrganizationMeter", id: node.id })
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.meterList.push({
              label: ele.roomNo + ">>" + ele.meterNo,
              value: ele.id,
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.$data.customerList = [];
    await this.$store
      .dispatch({ type: "customer/getOrganizationCustomer", id: node.id })
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.customerList.push({
              label: ele.name + ">>" + ele.mobile,
              value: ele.id,
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //保存数据
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "fictitiousmeter/create",
            data: this.meterPO,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  modelRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    meterNo: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    roomNo: [
      {
        trigger: "blur",
      },
    ],
    location: [
      {
        trigger: "blur",
      },
    ],
    priceId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    customerId: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  //区域
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //价格
  async getPrice() {
    this.$data.price = [];
    await this.$store
      .dispatch("price/getPriceList")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.price.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      organizations: [], //组织
      meterList: [], //总表信息
      price: [], //价格
      customerList: [], //客户信息
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
